import { apiPath } from '../../constants';
import { axios, apiRequestOptions, transformHttpResponse } from 'utils';

export const SCHEDULE_CATEGORIES_REQUEST = 'SCHEDULE_CATEGORIES_REQUEST';
export const SCHEDULE_CATEGORIES_SUCCESS = 'SCHEDULE_CATEGORIES_SUCCESS';
export const SCHEDULE_CATEGORIES_FAILURE = 'SCHEDULE_CATEGORIES_FAILURE';

/**
 * Fetches the categories a schedule plans: every one with entries, drawn or
 * not (`drawn: false` — counted by the draw it would make; ScheduleDrawRows,
 * organiser 29 Oct 2026). Filtering is enforced server-side.
 *
 * @param {string} competitionId
 */
export const fetchScheduleCategories = (competitionId) => {
  return function (dispatch) {
    dispatch({ type: SCHEDULE_CATEGORIES_REQUEST, competitionId });

    return axios(
      apiRequestOptions(apiPath.SCHEDULE.CATEGORIES, null, { params: { id: competitionId } })
    )
      .then(transformHttpResponse)
      .then(response =>
        dispatch({
          type: SCHEDULE_CATEGORIES_SUCCESS,
          competitionId,
          data: response.data.categories,
        })
      )
      .catch(error => transformHttpResponse(error.response))
      .catch(() => {
        dispatch({ type: SCHEDULE_CATEGORIES_FAILURE, competitionId });
      });
  };
};
